/**
 * Round flags, by two-letter country code. Each flag is its own small file, fetched by the
 * browser only when a chart shows it; this map holds just their addresses. A country we have no
 * flag for simply shows none.
 */
const FILES = import.meta.glob('/node_modules/flag-icons/flags/1x1/*.svg', { query: '?no-inline', import: 'default', eager: true })
const BY_CODE = {}
Object.entries(FILES).forEach(([path, url]) => { BY_CODE[path.slice(path.lastIndexOf('/') + 1, -4)] = url })

export const flagUrl = (iso2) => (iso2 ? BY_CODE[String(iso2).toLowerCase()] || null : null)
